import React, { useContext, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getLabel } from '../../data/labels';
import ReservationHistory from './ReservationHistory';
import { getConfiguration } from '../../data/utils';

function ReservationBox(props) {
	const betslipContext = useContext(BetslipContext) ;
  	const conf = getConfiguration();  
	const couponKey = props.couponKey;
    let reservations = betslipContext.getReservations();
    reservations = reservations == null? [] : reservations;
    const [reservationCode, setReservationCode] = useState('');

	
	function handleKeyPress(evt){
		const keyCode = evt.which || evt.keyCode;
		if(keyCode === 13){
			loadTicket();
		}
	}    
    function loadTicket(){
    	//alert('reload ticket ' + reservationCode);
    	if(reservationCode && reservationCode.length > 0){
	    	betslipContext.reloadReservedTicket(reservationCode);    	
    	}
    }

    return (
        <div className="contenuto-widget bordato-widget padding-orizzontale padding-verticale containerDisclaimerReservation">
            {
            	!window.appConfig.TERMINAL_AGENCY && (
                    <p className="disclaimerReservation">
                        {getLabel('carrello.reservation.disclaimer_part1').replaceAll('{{DAYS}}', conf.rps?.edr || 3)}
                        {getLabel('carrello.reservation.disclaimer_part2')}
                    </p>
            	)
            }

            <p className="reservationInputLabel"> 
                {getLabel('carrello.reservation.label_part1')} <span className={"grassetto"}>{ !conf.iwh && couponKey}</span> {getLabel('carrello.reservation.label_part2')}
            </p>
            <div className="input-widget">
                <input value={reservationCode} onKeyPress={handleKeyPress} onChange={e => setReservationCode(e.target.value + "")} className="input-personalizzato" type="text" id={"input-reservation-box-coupon-" + couponKey} placeholder={getLabel('carrello.reservation.code')} />
                <a onClick={() => {loadTicket()}}className="bottone bg-colore-1 bianco">{getLabel('general.carica')}</a>
            </div>
            {
                reservations.length > 0 &&(
                        <ReservationHistory reservations={reservations} />
                )
            }
        </div>
   );
}

export default ReservationBox;